import React, { useState } from 'react';
import ContactUsPopup from './ContactUsPopup';
import { AppleLogo, GoogleGLogo } from './AppIcons';

const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/hustle-dial/id6748039370';
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hustledial.hustledial';
const SEO_LINKS = [
  { href: '/focus-timer.html', label: 'Focus timer' },
  { href: '/study-timer.html', label: 'Study timer' },
  { href: '/deep-work-timer.html', label: 'Deep work timer' },
  { href: '/adhd-focus-timer.html', label: 'ADHD focus' },
  { href: '/habit-tracker-streaks.html', label: 'Habit streaks' },
  { href: '/mood-tracker-flow-state.html', label: 'Mood tracker' },
  { href: '/session-tracker.html', label: 'Session tracker' },
];

const SignupSection = () => {
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);

  return (
    <section id="download" className="hd-section relative overflow-hidden">
      <div className="hd-radial hd-radial-lime"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="hd-kicker text-lime">Available now</p>
            <h2 className="hd-display text-5xl md:text-7xl text-bone leading-[0.95] mt-5">
              Download
              <span className="block text-lime italic">Hustle Dial.</span>
            </h2>
            <p className="text-hdMuted text-lg md:text-xl leading-relaxed mt-7 max-w-xl">
              Hustle Dial is live on the App Store and Google Play. Pick your platform
              and start your next focus session.
            </p>

            <div className="mt-10 grid gap-3 sm:grid-cols-3 max-w-2xl">
              <div className="hd-mini-proof">
                <span>01</span>
                <strong>Free to download</strong>
              </div>
              <div className="hd-mini-proof">
                <span>02</span>
                <strong>iOS live now</strong>
              </div>
              <div className="hd-mini-proof">
                <span>03</span>
                <strong>Android live now</strong>
              </div>
            </div>
          </div>

          <div className="hd-signup-panel">
            <p className="hd-kicker text-lime">Get the app</p>
            <div className="mt-7 space-y-4">
              <a
                href={IOS_APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hd-submit flex items-center justify-center gap-3 no-underline"
                aria-label="Download Hustle Dial on the iOS App Store"
              >
                <AppleLogo className="w-6 h-6 shrink-0" />
                Download on iOS
              </a>

              <a
                href={ANDROID_PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hd-submit"
                aria-label="Download Hustle Dial on Google Play"
                style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: 'var(--hd-muted)' }}
              >
                <span className="flex items-center justify-center gap-3">
                  <GoogleGLogo className="w-6 h-6 shrink-0" />
                  Get it on Google Play
                </span>
              </a>
            </div>

            <div className="mt-6 text-sm text-hdMuted">
              <p>Free to download on iOS and Android.</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="relative z-10 mt-24">
        <div className="container mx-auto px-6">
          <div className="border-t border-white/10 pt-10">
            <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
              <div>
                <p className="hd-kicker text-lime">Hustle Dial</p>
                <p className="text-hdMuted mt-3">Time management reimagined.</p>
                <nav
                  className="mt-5 flex max-w-3xl flex-wrap gap-x-4 gap-y-2 text-sm text-hdMuted"
                  aria-label="Focus timer topic pages"
                >
                  {SEO_LINKS.map((link) => (
                    <a key={link.href} href={link.href} className="hover:text-lime transition-colors">
                      {link.label}
                    </a>
                  ))}
                </nav>
              </div>

              <div className="flex flex-col gap-4 text-sm text-hdMuted md:flex-row md:items-center md:gap-6">
                <p>&copy; 2026 Hustle Dial. All rights reserved.</p>
                <a href="/privacy-policy.html" className="hover:text-bone transition-colors">
                  Privacy Policy
                </a>
                <a href="/terms.html" className="hover:text-bone transition-colors">
                  Terms of Service
                </a>
                <button
                  type="button"
                  onClick={() => setIsContactPopupOpen(true)}
                  className="text-left hover:text-bone transition-colors"
                >
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ContactUsPopup
        isOpen={isContactPopupOpen}
        onClose={() => setIsContactPopupOpen(false)}
      />
    </section>
  );
};

export default SignupSection;
